const DEFAULT_LOCALE = 'en';
const SUPPORTED_LOCALES = ['en', 'zh', 'ja', 'ko', 'de'];

export default function prependLocaleToLinks() {
    const languageId = window.Liferay.ThemeDisplay.getLanguageId();
    const host = window.location.host;
    let currentLocale = languageId.split('_')[0];

    if (!SUPPORTED_LOCALES.includes(currentLocale)) {
        currentLocale = DEFAULT_LOCALE;
    }

    if (currentLocale === DEFAULT_LOCALE || document.body.classList.contains('has-edit-mode-menu')) {
        return;
    }

    if (host.endsWith('.cn') && currentLocale === 'zh') {
        return;
    }

    document
        .querySelectorAll(
            `[id^="fragment-"] a[href^="/"]:not([href^="/en/"]):not([href^="/zh/"]):not([href^="/ja/"]):not([href^="/ko/"]):not([href^="/de/"]):not([href^="/documents/"])`
        )
        .forEach($anchor => {
            $anchor.href = `/${currentLocale}${$anchor.getAttribute('href')}`;
        });
}
